export const BUSINESS_STATUSES = [
  { value: 'new_unprocessed', label: 'Новый', color: 'bg-sky-100 text-sky-800 dark:bg-sky-900/30 dark:text-sky-300' },
  { value: 'potential', label: 'Потенциальные', color: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300' },
  { value: 'to_review', label: 'Разобрать', color: 'bg-violet-100 text-violet-800 dark:bg-violet-900/30 dark:text-violet-300' },
  { value: 'not_relevant', label: 'Не актуально', color: 'bg-gray-100 text-gray-800 dark:bg-slate-700 dark:text-gray-300' },
  { value: 'client_active', label: 'Действующий клиент', color: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300' },
];

const LEGACY_STATUS_MAP = {
  active: 'new_unprocessed',
  inactive: 'not_relevant',
  dissolved: 'not_relevant',
};

const CRM_STATUS_MAP = {
  New: 'new_unprocessed',
  Potential: 'potential',
  'To review': 'to_review',
  'Not relevant': 'not_relevant',
  'Active client': 'client_active',
};

const AGENT_STATUS_MAP = {
  new: 'new_unprocessed',
  new_unprocessed: 'new_unprocessed',
  test_only: 'potential',
  draft_ready: 'potential',
  needs_review: 'potential',
  contact_found: 'potential',
  paused: 'potential',
  sent: 'potential',
  replied: 'potential',
  do_not_contact: 'not_relevant',
  not_relevant: 'not_relevant',
  to_review: 'to_review',
  client_active: 'client_active',
};

export const normalizeBusinessStatus = (status) => CRM_STATUS_MAP[status] || LEGACY_STATUS_MAP[status] || status || 'new_unprocessed';

export const normalizeAgentBusinessStatus = (status) => AGENT_STATUS_MAP[status] || normalizeBusinessStatus(status);

export const getBusinessPipelineStatus = (business) => {
  if (!business) {
    return 'new_unprocessed';
  }

  const rawStatus = business.status || '';
  if (rawStatus && !LEGACY_STATUS_MAP[rawStatus]) {
    return normalizeAgentBusinessStatus(rawStatus);
  }

  const notes = String(business.notes || '');
  const match = notes.match(/Outreach status:\s*([a-zA-Z0-9_-]+)/i);
  if (match) {
    return normalizeAgentBusinessStatus(match[1]);
  }

  return normalizeBusinessStatus(rawStatus);
};

export const getBusinessStatusConfig = (status) => {
  const normalized = typeof status === 'object'
    ? getBusinessPipelineStatus(status)
    : normalizeBusinessStatus(status);
  return BUSINESS_STATUSES.find(item => item.value === normalized) || {
    value: normalized,
    label: normalized,
    color: 'bg-gray-100 text-gray-800 dark:bg-slate-700 dark:text-gray-300',
  };
};

export const getBusinessStatusLabel = (status) => getBusinessStatusConfig(status).label;

export const getBusinessStatusColor = (status) => getBusinessStatusConfig(status).color;
